export default __webpack_public_path__ + "static/logo_dark-77450a914158cd9c59882856a10eabfc.svg";